import { Button, TextField, Modal, ModalContent, ModalFooterButtons, Loader } from "monday-ui-react-core";
import { useEffect, useState } from "react";
import MainService from "../../services/MainService";
import UrlConsts from "../../constants/UrlConstants";
import { sanitizeHtml } from "../../helper/sanitizeHtml";

interface Props {
    onLogin: (authen: boolean) => void;
    context: any;
}

const FormLogin: React.FC<Props> = ({ context, onLogin }) => {
    const [formReady, setFormReady] = useState<boolean>(false);
    const [statusLogin, setStatusLogin] = useState<any>();
    const [signingIn, setSigningIn] = useState<boolean>(false);
    const [password, setPassword] = useState<string>('');
    const [isSignUp, setIsSignUp] = useState<boolean>(false);
    const [showResetPass, setShowResetPass] = useState<boolean>(false);
    const [showChangePass, setShowChangePass] = useState<boolean>(false);
    const [oldPassword, setOldPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [resetUsers, setResetUsers] = useState<any>();

    useEffect(() => {
        async function fetchData() {
            await setFormReady(false);
            await onLogin(false);
            await initLogin();
            await setFormReady(true);
        }

        fetchData(); // Call the function to fetch data when component mounts
    }, []);


    async function initLogin() {
        setResetUsers(context?.owners);
        const login = await checkIsLogin();
        if (!login) {
            const signup = await checkIsSignUp();
            await setIsSignUp(signup);
        } else {
            await setSigningIn(false);
            await setIsSignUp(true);
            await onLogin(true);
        }
    }

    async function checkIsLogin() {
        const token = MainService.getToken();
        if (token?.token?.length && new Date() < new Date(parseInt(token?.expiresDate))) {
            MainService.token = token.token;
            const updatedPassDate = await MainService.post({ accountId: context?.accountId, boardId: context?.boardId }, UrlConsts.verifyToken);
            if (!updatedPassDate?.data || new Date(parseInt(token?.startDate)) >= new Date(parseInt(updatedPassDate?.data))) {
                return true;
            }
        }

        MainService.removeToken();
        return false;
    }

    async function checkIsSignUp() {
        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId
        };
        const isHaveInfo = await MainService.postNoAuthen(data, UrlConsts.isSignUp);
        return isHaveInfo;
    }

    async function handleLoginClick() {
        setSigningIn(true);
        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            password: password
        }

        const rs = await MainService.postNoAuthen(data, UrlConsts.login);
        if (rs?.data && rs?.token?.token?.length) {
            MainService.setToken(rs.token);
        }
        setStatusLogin({ status: rs?.data ? '' : 'error', text: rs?.data ? '' : 'Password incorrect' });
        setSigningIn(false);
        onLogin(rs?.data);
    }

    function handlePassword(event) {
        setPassword(event);
        if (!event?.length) setStatusLogin({ status: '', text: '' });
    }

    function handleOldPassword(event) {
        setOldPassword(event);
        if (!event?.length) setStatusLogin({ status: '', text: '' });
    }

    function handleNewPassword(event) {
        setNewPassword(event);
        if (!event?.length) setStatusLogin({ status: '', text: '' });
    }

    async function handleCreatePassClick() {
        setSigningIn(true);
        MainService.notice('Creating password...', 'info');
        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            password: password
        }
        const createPass = await MainService.postNoAuthen(data, UrlConsts.createPassword);
        if (createPass) {
            MainService.notice('Create password successfully!!!');
        } else {
            MainService.notice('Something went wrong...', 'error');
        }

        setIsSignUp(createPass);
        setSigningIn(false);
        onLogin(createPass);
    }

    async function handleRequestResetPassword() {
        MainService.notice('Sending request...', 'info');
        const reset = await MainService.requestResetPassword(context, resetUsers);
        if (reset) MainService.notice('Sent');
        else MainService.notice('Something went wrong...', 'error');
        await setShowResetPass(false);
    }

    async function handleChangePassword() {
        MainService.notice('Changing Password...', 'info');
        await setStatusLogin(null);
        if (!oldPassword?.length || !newPassword?.length) {
            if (!oldPassword?.length) await setStatusLogin({ oldPass: { status: 'error', text: 'Password invalid' } });
            if (!newPassword?.length) await setStatusLogin({ newPass: { status: 'error', text: 'Password invalid' } });
            MainService.notice('Something went wrong...', 'error');
            return;
        }

        const data = {
            accountId: context?.account?.id,
            boardId: context?.boardId,
            password: oldPassword,
            newPassword: newPassword
        }
        const rs = await MainService.postNoAuthen(data, UrlConsts.changePasswordNo);
        const reset = rs?.data;
        if (reset?.status) {
            setShowChangePass(false);
            setOldPassword('');
            setNewPassword('');
            MainService.removeToken();
            MainService.notice('Password Changed Successfully!!!');
        } else {
            if (reset?.message === 'Incorrect old password')
                setStatusLogin({ oldPass: { status: 'error', text: 'Incorrect old password' } });
            MainService.notice('Something went wrong...', 'error');
        }
        // if (reset.status) MainService.notice('Password Changed Successfully!!!');
        // else MainService.notice(reset.message, 'error');
        // await setShowChangePass(false);
    }

    function handleCloseChangePassword() {
        setOldPassword('');
        setNewPassword('');
        setShowChangePass(false);
    }
function getSafeStatus(status: any): 'success' | 'error' | undefined {
	const safe = sanitizeHtml(status);
	if (safe === 'success' || safe === 'error') return safe;
	return undefined; // Không hợp lệ thì không truyền gì cả
}

return (
	<div className='max-w-md m-auto mt-10'>
		{!formReady ? (
			<div className='inline-block mt-16'>
				<Loader
					className='custom-loader-form'
					hasBackground={true}
					size={64}
				/>
			</div>
		) : (
			<>
				<div>
					{!isSignUp && (
						<TextField
							placeholder='Password'
							title='Create your password'
							type={TextField.types.PASSWORD}
							wrapperClassName='monday-storybook-text-field_size'
							value={password}
							onChange={(event: string) => handlePassword(event)}
						/>
					)}

					{isSignUp && (
						<TextField
							placeholder='Password'
							title='Enter your password'
							type={TextField.types.PASSWORD}
							wrapperClassName='monday-storybook-text-field_size'
							value={password}
							onChange={(event: string) => handlePassword(event)}
							validation={{
								status: getSafeStatus(statusLogin?.status),
								text: sanitizeHtml(statusLogin?.text),
							}}
						/>
					)}

					{/* modal change password */}
					<Modal
						show={showChangePass}
						onClose={handleCloseChangePassword}
						title=' '>
						<ModalContent>
							<TextField
								placeholder='Old Password'
								title='Old password'
								type={TextField.types.PASSWORD}
								wrapperClassName='monday-storybook-text-field_size'
								value={oldPassword}
								onChange={(event: string) => handleOldPassword(event)}
								validation={{
									status: getSafeStatus(statusLogin?.oldPass?.status),
									text: sanitizeHtml(statusLogin?.oldPass?.text),
								}}
							/>
							<div className='mt-3'>
								<TextField
									placeholder='New Password'
									title='New password'
									type={TextField.types.PASSWORD}
									wrapperClassName='monday-storybook-text-field_size'
									value={newPassword}
									onChange={(event: string) => handleNewPassword(event)}
									validation={{
										status: getSafeStatus(statusLogin?.newPass?.status),
										text: sanitizeHtml(statusLogin?.newPass?.text),
									}}
								/>
							</div>
						</ModalContent>
						<ModalFooterButtons
							onPrimaryButtonClick={handleChangePassword}
							onSecondaryButtonClick={handleCloseChangePassword}
							primaryButtonText='Confirm'
							secondaryButtonText='Cancel'
						/>
					</Modal>

					{/* modal reset password */}
					<Modal
						show={showResetPass}
						onClose={() => {
							setShowResetPass(false);
						}}
						title='Request to reset password?'>
						<ModalContent>
							<p className='mt-5'>A password reset request will be sent to the board owner. Please contact them to receive the new password.</p>
							<br />
							<br />
						</ModalContent>
						<ModalFooterButtons
							onPrimaryButtonClick={handleRequestResetPassword}
							onSecondaryButtonClick={() => {
								setShowResetPass(false);
							}}
							primaryButtonText='Confirm'
							secondaryButtonText='Cancel'
						/>
					</Modal>
				</div>
				<div className='flex'>
					<span
						onClick={() => {
							setShowResetPass(true);
						}}
						className='flex-1 text-left text-blue-400 underline hover:cursor-pointer hover:font-medium'>
						Reset Password?
					</span>
					{context.isOwner && (
						<span
							onClick={() => {
								setShowChangePass(true);
							}}
							className='flex-1 text-right text-blue-400 underline hover:cursor-pointer hover:font-medium'>
							Change Password
						</span>
					)}
				</div>
				<div className='mt-5 text-right'>
					{!isSignUp && (
						<Button
							onClick={handleCreatePassClick}
							loading={signingIn}
							className='text-center'>
							Create Password
						</Button>
					)}
					{isSignUp && (
						<Button
							onClick={handleLoginClick}
							loading={signingIn}
							className='text-center'>
							Login
						</Button>
					)}
				</div>
			</>
		)}
	</div>
);
}


export default FormLogin;